/**
 * @generated SignedSource<<f2346cf8ffb63e865fd1c8f1cb210462>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type stripeConnectorPage_KeyConnectMutation$variables = {
  apiKey: string;
};
export type stripeConnectorPage_KeyConnectMutation$data = {
  readonly stripeKeyConnect: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly status: {
      readonly connected: boolean;
      readonly keyPresent: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type stripeConnectorPage_KeyConnectMutation = {
  response: stripeConnectorPage_KeyConnectMutation$data;
  variables: stripeConnectorPage_KeyConnectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "apiKey"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "apiKey",
    "variableName": "apiKey"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connected",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "keyPresent",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "stripeConnectorPage_KeyConnectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StripeKeyConnectMutationPayload",
        "kind": "LinkedField",
        "name": "stripeKeyConnect",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeConnectionStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "stripeConnectorPage_KeyConnectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "StripeKeyConnectMutationPayload",
        "kind": "LinkedField",
        "name": "stripeKeyConnect",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StripeConnectionStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "31cd6a5d4b630af220e7fde101618a9f",
    "id": null,
    "metadata": {},
    "name": "stripeConnectorPage_KeyConnectMutation",
    "operationKind": "mutation",
    "text": "mutation stripeConnectorPage_KeyConnectMutation(\n  $apiKey: String!\n) {\n  stripeKeyConnect(apiKey: $apiKey) {\n    status {\n      connected\n      keyPresent\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c72e259b9cc86b776302c69058ef8349";

export default node;
